import { render, staticRenderFns } from "./treasuregen.vue?vue&type=template&id=b2b59e86&scoped=true&"
import script from "./treasuregen.vue?vue&type=script&lang=js&"
export * from "./treasuregen.vue?vue&type=script&lang=js&"
import style0 from "./treasuregen.vue?vue&type=style&index=0&id=b2b59e86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b59e86",
  null
  
)

export default component.exports